import { combineReducers } from "redux";
import api from "APP_ROOT/api";
import {
  createPaginatedList,
  paginationGroup
} from "MODULES/shared/pagination";

export const partInventories = createPaginatedList({
  listId: "part/inventories",
  fetch: api.parts.inventories.search,
  stateLocator: state => state.partPagination.inventories
});

export const incomingQuotesPagination = createPaginatedList({
  listId: "part/incomingQuoteLineItems",
  fetch: (id, search) => api.parts.incomingQuoteLineItems.search(id, search),
  stateLocator: state => state.partPagination.incomingQuoteLineItems
});

export const outgoingQuotesPagination = createPaginatedList({
  listId: "part/outgoingQuoteLineItems",
  fetch: api.parts.outgoingQuoteLineItems.search_grouped,
  stateLocator: state => state.partPagination.outgoingQuoteLineItems
});

export const lotsPagination = createPaginatedList({
  listId: "part/lotLineItems",
  fetch: api.parts.lotLineItems.search,
  stateLocator: state => state.partPagination.lotLineItems
});

export const purchaseOrdersPagination = createPaginatedList({
  listId: "part/purchaseOrderLineItems",
  fetch: api.parts.purchaseOrderAndLots.search,
  stateLocator: state => state.partPagination.purchaseOrderLineItems
});

export const managedRepairsPagination = createPaginatedList({
  listId: "part/managedRepairLineItems",
  fetch: api.parts.managedRepairOrderLineItems,
  stateLocator: state => state.partPagination.managedRepairOrderLineItems
});

export const repairQuotesPagination = createPaginatedList({
  listId: "part/repairQuoteLineItems",
  fetch: api.parts.repairQuoteLineItems.search,
  stateLocator: state => state.partPagination.repairQuoteLineItems,
  initialSettings: {
    sort: "updated_at"
  }
});

export const salesOrdersPagination = createPaginatedList({
  listId: "part/salesOrderLineItems",
  fetch: api.parts.salesOrderLineItems.search,
  stateLocator: state => state.partPagination.salesOrderLineItems
});

export const partsPagination = createPaginatedList({
  forceDebounce: true,
  listId: "parts",
  fetch: api.parts.search,
  stateLocator: state => state.partPagination.main,
  initialSettings: {
    sort: "base_part_number"
  }
});

const partsApi = key => (id, { page, limit }) =>
  api.parts[key].list(id, page, limit);

export const config = (key, collect = true, endpoint = partsApi(key)) => ({
  key,
  collect,
  api: endpoint
});

const [
  applications,
  alternates,
  incomingQuoteLineItems,
  detailIncomingQuoteLineItems,
  outgoingQuoteLineItems,
  detailOutgoingQuoteLineItems,
  inventories,
  lotLineItems,
  managedRepairOrderLineItems,
  purchaseOrderLineItems,
  repairOrderLineItems,
  repairQuoteLineItems,
  detailPurchaseOrderLineItems,
  salesOrderLineItems,
  detailSalesOrderLineItems
] = paginationGroup(
  {
    groupName: "part",
    getId: state => state.partDetail.getIn(["part", "id"]),
    locate: ({ key }) => state => state.partPagination[key]
  },
  config("applications"),
  config("alternates", false, api.parts.alternates.search),
  config(
    "incomingQuoteLineItems",
    false,
    api.parts.incomingQuoteLineItems.search
  ),
  config(
    "detailIncomingQuoteLineItems",
    false,
    api.parts.incomingQuoteLineItems.search
  ),
  config(
    "outgoingQuoteLineItems",
    false,
    api.parts.outgoingQuoteLineItems.search_grouped
  ),
  config(
    "detailOutgoingQuoteLineItems",
    false,
    api.parts.outgoingQuoteLineItems.search
  ),
  config("inventories", false, api.parts.inventories.search),
  config("lotLineItems", false, api.parts.lotLineItems.search),
  config(
    "managedRepairOrderLineItems",
    false,
    api.parts.managedRepairOrderLineItems.search
  ),
  config(
    "purchaseOrderLineItems",
    false,
    api.parts.purchaseOrderAndLots.search
  ),
  config("repairOrderLineItems", false, api.parts.repairOrderLineItems.search),
  config("repairQuoteLineItems", false, api.parts.repairQuoteLineItems.search),
  config(
    "detailPurchaseOrderLineItems",
    false,
    api.parts.purchaseOrderLineItems.search
  ),
  config("salesOrderLineItems", false, api.parts.salesOrderLineItems.search),
  config(
    "detailSalesOrderLineItems",
    false,
    api.parts.salesOrderLineItems.search
  )
);

export default combineReducers({
  main: partsPagination.paginator,
  applications,
  alternates,
  incomingQuoteLineItems,
  detailIncomingQuoteLineItems,
  outgoingQuoteLineItems,
  detailOutgoingQuoteLineItems,
  inventories,
  lotLineItems,
  managedRepairOrderLineItems,
  purchaseOrderLineItems,
  repairOrderLineItems,
  repairQuoteLineItems,
  detailPurchaseOrderLineItems,
  salesOrderLineItems,
  detailSalesOrderLineItems
});



// WEBPACK FOOTER //
// ./app/modules/parts/pagination.js